import { render, staticRenderFns } from "./TirantPrimeConversa.vue?vue&type=template&id=92f3ecda&lang=pug&"
import script from "./TirantPrimeConversa.vue?vue&type=script&lang=js&"
export * from "./TirantPrimeConversa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports